// extracted by mini-css-extract-plugin
export default {"pagination":"UI_pagination_pagination__+zs4z","page":"UI_pagination_page__8MuHD","activePage":"UI_pagination_activePage__m+ti6"};